/* What every page needs once: the shop, the app settings, the server config (Gmail, paint folder) and the paint
 * product. Loaded in parallel at start; each page reads it from context. */
import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import { shopInfo, paintProduct, finderAddons } from './admin.js';
import { getConfig } from './server.js';
import { paintCatalog } from './paint.js';
import { settingsWith } from './email.js';

export const AppState = createContext(null);
export const useApp = () => useContext(AppState);

export async function loadAppState() {
  const [shop, config, paint] = await Promise.all([
    shopInfo(),
    getConfig().catch((e) => ({ error: e.message, gmail: { connected: false }, paintBase: null })),
    paintProduct().catch((e) => ({ error: e.message })),
  ]);
  const addons = await finderAddons(config.finder).catch(() => ({}));
  return {
    shop,
    settings: settingsWith(shop.settings),
    config,
    addons,
    paint: paint.error ? null : paintCatalog(paint),
    paintError: paint.error || null,
  };
}

export const adminUrl = (gid, kind) => `shopify://admin/${kind}/${String(gid || '').split('/').pop()}`;
export const idOf = (gid) => String(gid || '').split('/').pop();
export const draftGid = (id) => (String(id).startsWith('gid://') ? id : `gid://shopify/DraftOrder/${id}`);
